import React, { useState, useEffect } from 'react';

import styled from 'styled-components';

// material-ui icons
import AspectRatioIcon from '@mui/icons-material/AspectRatio';
import SaveAltIcon from '@mui/icons-material/SaveAlt';
import DriveFileMoveIcon from '@mui/icons-material/DriveFileMove';
import SettingsBackupRestoreIcon from '@mui/icons-material/SettingsBackupRestore';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import TouchAppIcon from '@mui/icons-material/TouchApp';
import RemoveDoneIcon from '@mui/icons-material/RemoveDone';
import JoinFull from '@mui/icons-material/JoinFull';
import JoinRight from '@mui/icons-material/JoinRight';
import PhotoAlbum from '@mui/icons-material/PhotoAlbum';

// IMPORT FUNCTIONS
import getUrl from  "../../../../utils/functions/getUrl";
import setImageStatus from '../../../../services/setImageStatus';
import resizeFile from '../../../../utils/functions/resizeFile';
import saveImagesToServer from '../../../../utils/functions/uploadImages'
import delay from '../../../../utils/functions/delay'
import addToFolder from '../../../../utils/functions/addToFolder';
import removeImageFromAlbum from '../../../../utils/functions/removeImageFromAlbum';

// IMPORT LOCAL FUNCTIONS
import deleteImage from './functions/deleteImage';

// IMPORT COMPONENTS
import UploadAndDisplayImage from '../UploadAndDisplayImage';
import PostDataComplex from '../../../../services/PostDataComplex';

// IMPORT COMMON COMPONENTS
import PictureHolder from '../../../../utils/components/PictureHolder/PictureHolder';

// IMPORT DATA FOR LOCAL USE
import getImagesData from './getImagesData';


const PictureContainer = ( { showDeletedImages, setToggleMessageModal, setMessage, setErrorMessage, handleImageModalExpand, albums, setMessageTitle, associatedAlbumId, setAssociatedAlbumId, setDessociatedAlbumId, assoc, setToggleRemoveImageFromAlbumModal, setRemoveImageFromAlbumDataModal, removeImageFromAlbumDataModal, answerRemoveImageFromAlbumModal, setAnswerRemoveImageFromAlbumModal, inAlbumOnly, setToggleDeleteImageModal, deleteImageDataModal, setDeleteImageDataModal, answerDeleteImageModal, setAnswerDeleteImageModal }) => {

  const BASE_URL = getUrl();
  console.log(`BASE_URL: ${BASE_URL}`);

  const [images, setImages] = useState(null);
  const [imageRemoved, setImageRemoved] = useState(false);
  const [imageDeleted, setImageDeleted] = useState(0);

  const [imageData, setImageData] = useState(null);

  const [mini] = useState(BASE_URL + '/uploaded/mini/');

  const [ selectedImages, setSelectedImages ] = useState([])

  const [ imagesSelected, setImagesSelected ] = useState(false)
  const [ newImageAdded, setNewImageAdded ] = useState(false)

  const [expandImage, setExpandImage] = useState(false)

  // 
  // USE EFFECT(s)
  // 

  // 
  // load user related ALL images
  // 
  useEffect(()=>{
    console.log(`useEffect->handleLoadImages() ---`)
    handleLoadImages(showDeletedImages, inAlbumOnly);
    
    imageRemoved && setImageRemoved(false);

    setNewImageAdded(false)


  },[inAlbumOnly, imageRemoved, imageDeleted, showDeletedImages, newImageAdded ]);

  // 
  // console images
  // 
  useEffect(()=>{
    
    console.log('images:->');
    console.log(images);
    
  },[images]);
  
  // 
  // resize image
  // 
  useEffect(()=>{
    
    images && createImageThumbnail(images);

  },[images]);

  // 
  // 
  // 
  useEffect(()=>{
    if(associatedAlbumId) {
      // get data from associated albums 
      // getAlbumImages(associatedAlbumId);
      setAssociatedAlbumId(null);
    }

  },[associatedAlbumId]);


  // 
  // HANDLERS
  // 

  // 
  // load images data from db
  // 
  const handleLoadImages = async (showDeletedImages, inAlbumOnly) => {
    console.log(`handleLoadImages()`);

    console.log(`showDeletedImages: ${showDeletedImages}`);
    console.log(`inAlbumOnly: ${inAlbumOnly}`);

    // const tokenStored = sessionStorage.getItem('userData');
    const token = (JSON.parse(sessionStorage.userData)).user.token;
    console.log(`token: ${token}`);
    const user = (JSON.parse(sessionStorage.userData)).user.usr_name;
    console.log(`user: ${user}`);
    const email = (JSON.parse(sessionStorage.userData)).user.usr_email;
    console.log(`email: ${email}`);
    const id = (JSON.parse(sessionStorage.userData)).user.id;
    console.log(`id: ${id}`);

    const data = {
      user: user,
      token: token,
      status: !showDeletedImages ? 'active' : 'inactive'
    }

    console.log('data:->');
    console.log(data);

    const localHost = String(window.location).split('/')[2].includes('localhost');
    const network = String(window.location).split('/')[2].includes('10.0.0.6');
    console.log(`localHost: ${localHost}`);
    console.log(`network: ${network}`);
    
    if( localHost || network ) {
      console.log('LOCALE!!!')

      // const fakeResponse = imagesData
      if(getImagesData.images) {
        console.log('getImagesData.images:->');
        console.log(getImagesData.images);
        console.log('Images uploaded succesfully!!!');

        const imagesToDisplay = []
        if(showDeletedImages) {
          getImagesData.images.map(image=>image.status==='inactive' ? imagesToDisplay.push(image) : '')
        } else {
          console.log('showDeletedImages is false!');
          getImagesData.images.map(image=>(image.status==='active' || !image.status) ? imagesToDisplay.push(image) : '')
        }
        console.log(`imagesToDisplay: ${JSON.stringify(imagesToDisplay)}`)
        console.log(`assoc: ${JSON.stringify(assoc)}`)

        var result = []
        
        if(inAlbumOnly) {
          const array1 = [...imagesToDisplay]
          console.log(`array1: ${JSON.stringify(array1)}`)
          const array2 = [...assoc]
          console.log(`array2: ${JSON.stringify(array2)}`)

          for(let i=0; i<array1.length; i++) {
            let est = false

            for(let j=0; j<array2.length; j++) {
              console.log(`array1[${i}].id: ${array1[i].id}`)
              console.log(`array2[${j}].img_id: ${array2[j].img_id}`)
              if(Number(array1[i].id) === array2[j].img_id) {
                est = true
                console.log(`break`)
                break
              }
            }
            if(!est) {
              result.push(array1[i])
            }
          }
          
          for (let i=0; i<10; i++) {
            console.log(`i: ${i}`)
          }

        } else {
          result = imagesToDisplay.slice(0)
        }

        console.log(`result: ${JSON.stringify(result)}`)
        console.log(`result.length: ${result.length}`)
          
        console.log(`going to setImages`)
        setImages(result.reverse());
        console.log(`setImages done`)

        console.log('Images upload succesfully!!!');

      } else {
        console.log('Images upload error!!!');
      }

    } else {

      await PostDataComplex('images_manager', 'POST', 'getImages', data)
      // PostData('POST', 'getImages', userData)
        .then((response) => {
          console.log('getImages response.data:->');
          console.log(response.data);

          const getImagesData = response.data.feedBack.getImagesData.getImagesResult;

          if(getImagesData.images) {
            console.log('Images uploaded succesfully!!!');

            console.log(`getImagesData.images: ${JSON.stringify(getImagesData.images)}`)
            console.log(`assoc: ${JSON.stringify(assoc)}`)


            let result = []
        
            if(inAlbumOnly) {
              const array1 = [...getImagesData.images]
              console.log(`array1: ${JSON.stringify(array1)}`)
              const array2 = [...assoc]
              console.log(`array2: ${JSON.stringify(array2)}`)

              for(let i=0; i<array1.length; i++) {
                let est = false

                for(let j=0; j<array2.length; j++) {
                  console.log(`array1[${i}].id: ${array1[i].id}`)
                  console.log(`array2[${j}].img_id: ${array2[j].img_id}`)
                  if(Number(array1[i].id) === array2[j].img_id) {
                    est = true
                    console.log(`break`)
                    break
                  }
                }
                if(!est) {
                  result.push(array1[i])
                }
              }
              
              console.log(`result: ${JSON.stringify(result)}`)
              console.log(`result.length: ${result.length}`)
              
              for (let i=0; i<10; i++) {
                console.log(`i: ${i}`)
              }
            } else {
              result = getImagesData.images
            }

            console.log(`going to setImages`)
            setImages([...result].reverse());
            console.log(`setImages done`)
            
          } else {
            console.log('Images upload error!!!');
            setImages([]);
          }
        }
      )
    }
  };



  // 
  // uploading images to server
  //  

  const handleSetImage = async (images) => {
    console.log(`handleSetImage()`);

    setToggleMessageModal(true);
    setMessage(`Please wait while uploading image ...`);
    
    let res
    for(let imageNumber=0; imageNumber < images.length; imageNumber++) {

      setMessage(``);
      setErrorMessage(``);
      setMessage(`Please wait while uploading image ... ${imageNumber+1}/${images.length}`);
      res = await saveImagesToServer(images[imageNumber]);

      res[1] && setMessage(res[1]);
      res[2] && setErrorMessage(res[2]);

      setNewImageAdded(true)

      await delay(500)

    }


    setToggleMessageModal(false);

  }


// 
// 
// 
  let counterDeleteImages = 0
  let resDeleteImages
  
  async function recursiveDeleteImage(imagesToDelete){

    console.log(`imagesToDelete[${counterDeleteImages}].img_name: ${imagesToDelete[counterDeleteImages].img_name}`)

    setToggleMessageModal(true);
    setMessage(`Please wait while permanently delete selected image ${imagesToDelete.length - counterDeleteImages}`);

    resDeleteImages = await handleDelete(imagesToDelete[counterDeleteImages]);
    // resDeleteImages = await testDeleteImage(imagesToDelete[counterDeleteImages]);
    console.log(`called permanently delete with return value = ${resDeleteImages}`);

    if(resDeleteImages < imagesToDelete.length-1){
      return await recursiveDeleteImage(imagesToDelete);
    }

    return 'Selected Images Deleted';

  }

  // 
  // 
  // 
  const deleteSelectedImages = async () => {
    console.log(`deleteSelectedImages()`)
    // console.log(`image: ${JSON.stringify(image)}`);

    const imagesToDelete = []
    images.map(image => 
      image.selected === true &&
      imagesToDelete.push(image)
    )

    console.log(`imagesToDelete: ${JSON.stringify(imagesToDelete)}`)

    let finalRes = await recursiveDeleteImage(imagesToDelete);
    console.log(finalRes);

    setMessage(``);
    setToggleMessageModal(false);

  }
  // 
  // 
  // 



  // 
  // 
  // 
  const handleAddToFolder = async (e, image_id, image_name, album_name, album_id, album_usr) => {
    console.log(`handleAddToFolder()`);

    console.log(`image id: ${image_id}`);
    console.log(`image name: ${image_name}`);
    console.log(`album id: ${album_id}`);
    console.log(`album name: ${album_name}`);
    console.log(`album user: ${album_usr}`);
    console.log(`e: ${e}`);

    const resAlbum_id = await addToFolder(image_id, image_name, album_name, album_id, album_usr)
    console.log(`resAlbum_id: ${resAlbum_id}`);

    setAssociatedAlbumId(resAlbum_id)

  }


  // 
  // 
  // 
  const handleSelectImage = ( e, currImage, idx, status ) => {
    console.log(`handleSelectImage()`);

    console.log(`e:->`);
    console.log(e);
    console.log(`currImage:->`);
    console.log(currImage);
    console.log(`idx: ${idx}`);

    const selectedImage = images[idx]
    console.log(`selectedImage: ${JSON.stringify(selectedImage)}`)
    selectedImage.selected === true ? selectedImage.selected = false : selectedImage.selected = true

    const newImages = images.map((image) => { 
      return{
        ...image
      }
    })
    console.log(`images: ${JSON.stringify(images)}`);



    setImages(newImages)

  }
  // 
  // 
  // 

  
  useEffect(()=>{
    console.log(`setSelectedImages: ${JSON.stringify(selectedImages)}`)

  },[selectedImages])

  
  // 
  // 
  async function doRemoveImageFromAlbum(imageId, idx, albumId) {

    const res = await removeImageFromAlbum(imageId, idx, albumId)
    if(res>-1) {
      setDessociatedAlbumId(prev => prev + 1)
    }

  }
     
  // 
  // 

  async function removeImageFromAllAlbum(removeImageFromAlbumDataModal) {

    let res
    for(let i=0; i<removeImageFromAlbumDataModal.albumArray.length; i++) {

      const imageId = removeImageFromAlbumDataModal.image_id
      const idx = removeImageFromAlbumDataModal.idx
      const albumId = removeImageFromAlbumDataModal.albumArray[i]

      console.log(`i: ${i}`)
      console.log(`imageId: ${imageId}`)
      console.log(`idx: ${idx}`)
      console.log(`albumId: ${albumId}`)

      res = await removeImageFromAlbum(imageId, idx, albumId)
    }
    setDessociatedAlbumId(prev => prev + 1)

    console.log(`waiting for 1000 milliseconds`)
    delay(1000)
    
    const status = 'inactive'
    doSetImageStatus(removeImageFromAlbumDataModal.image_id, status)

  }
  

  // 
  // wait for the RemoveImageFromAlbumModal answer (yes/no)
  // 
  useEffect(()=>{
    if(answerRemoveImageFromAlbumModal === 'yes') {
      console.log(`removeImageFromAlbumDataModal: ${JSON.stringify(removeImageFromAlbumDataModal)}`)

      removeImageFromAllAlbum(removeImageFromAlbumDataModal)

    }
    setToggleRemoveImageFromAlbumModal(false)
    setAnswerRemoveImageFromAlbumModal('')
    // setRemoveImageFromAlbumDataModal({})


  },[answerRemoveImageFromAlbumModal])
  // 

  // Set status in pv_imgs and  pv_img_album_assoc
  //  to 'active' or 'inactive'
  // 
  const handleImageStatus = async (e, currImage, idx, status) => {
    console.log(`handleStatus()`);

    console.log(`e:->`);
    console.log(e);
    console.log(`currImage:->`);
    console.log(currImage);
    console.log(`idx: ${idx}`);
    console.log(`status: ${status}`);

    const assocAlbumArray = []

    if(status === 'inactive') {
      // check if image is associated with an ALbum
      console.log(`assoc: ${JSON.stringify(assoc)}`)
      let imageAssociatedWithOneAlbum = false
      for(let i=0; i<assoc.length; i++) {
        console.log(`i: ${i}`)
        console.log(`assoc[${i}].img_id: ${assoc[i].img_id}`)
        console.log(`typeof(assoc[${i}].img_id): ${typeof(assoc[i].img_id)}`)
        console.log(`currImage.id: ${currImage.id}`)
        console.log(`typeof(currImage.id): ${typeof(currImage.id)}`)

        // check if the image is associated with an Album
        if(assoc[i].img_id === Number(currImage.id)) {
          // console.log('this image is at least associated with one album!!! ')
          imageAssociatedWithOneAlbum = true

          assocAlbumArray.push(assoc[i].album_id)

        }
      }
      
      !imageAssociatedWithOneAlbum &&  console.log('this image is not associated with any album!!! ')

      if(imageAssociatedWithOneAlbum) {
        console.log('this image is at least associated with one album!!! ')

        
        //  request permission to remove the image from the album and delete the image
        setToggleRemoveImageFromAlbumModal(true)
        setRemoveImageFromAlbumDataModal({
          albumArray: assocAlbumArray,
          idx: idx,
          image_id: Number(currImage.id)
        })
      }
      else {
        setToggleDeleteImageModal(true)
        setDeleteImageDataModal({
          idx: idx,
          image_id: Number(currImage.id)
        })
        // doSetImageStatus(currImage.id, status)
      }
   } else {
      doSetImageStatus(currImage.id, status)
    } 

  }

  // 
  // 
  function doSetImageStatus(imageId, status) {

    const setToStatus = status;

    async function imageSettedTo(result) {
      console.log(`imageSettedTo()`);

      console.log(`result:->`);
      console.log(result);

      setMessageTitle('Remove Image Result');
      setToggleMessageModal(true);

      if(result.imagestatus) {
        console.log(`imageSettedTo success`);
        setImageRemoved(true);
        status === 'active' && setMessage('image restored succesfully!!!');
        status === 'inactive' && setMessage('image removed succesfully!!!');
        setErrorMessage(null);
        setToggleMessageModal(true);
      } else {
        console.log(`imageSettedTo insuccess!!!`);
        status === 'active' && setErrorMessage('error restoring image!!!');
        status === 'inactive' && setErrorMessage('error removing image!!!');
        setMessage(null);
      }

      await delay(1200)
      setToggleMessageModal(false);

    }

    // this is a function, NOT a useState
    setImageStatus(imageId, setToStatus, imageSettedTo);

  }
  // 
  // 

  
  // 
  // wait for the DeeteImageModal answer (yes/no)
  // 
  useEffect(()=>{

    console.log(`answerDeleteImageModal: ${removeImageFromAlbumDataModal}`)

    if(answerDeleteImageModal === 'yes') {
      console.log(`deleteImageDataModal: ${JSON.stringify(deleteImageDataModal)}`)

      doSetImageStatus(deleteImageDataModal.image_id, 'inactive')

    }
    setToggleDeleteImageModal(false)
    setAnswerDeleteImageModal('')

  },[answerDeleteImageModal])
  // 



  // 
  // delete permanently the image and thumbimage from the server folder 
  // delete the image and the thuimbimage from pv_images and from pv_img_album_assoc
  // 
  // const handleDelete = (e, currImage, idx) => {
  const handleDelete = async (currImage) => {
    console.log(`handleDelete()`);

    console.log(`currImage:->`);
    console.log(currImage);

    function imageDeleted(result) {
      console.log(`imageDeleted()`);

      console.log(`result:->`);
      console.log(result);

      setMessageTitle('Delete Image Result');
      setToggleMessageModal(true);

      if(result.imagesDeleted) {
        console.log(`imagesDeleted success`);
        setImageDeleted(prev => prev + 1);
        setMessage(result.message);
        setErrorMessage(null);
        setToggleMessageModal(true);
      } else {
        console.log(`imagesDeleted insuccess!!!`);
        setErrorMessage(result.error);
        setMessage(null);
      }

    }

    await deleteImage(currImage.id, imageDeleted);

  return counterDeleteImages++;


  }

  // 
  // FUNCTIONS
  //
  
  const createImageThumbnail = async (images) => {
    const imageToResize = `../uploaded/imgs/${images[0].img_name}`;
    console.log(`image to resize: ${imageToResize}`);
    const resizedImage = await resizeFile(imageToResize);
    console.log('resizedImage:->');
    console.log(resizedImage);
    console.log('++++++++++++++++++++++++++++++++++++++++++++++++');
  }


  useEffect(()=>{
    let imgsSelected = false
    if(images && images.length>0) {
      for(let i=0; i<images.length; i++) {
        if(images[i].selected === true){
          imgsSelected = true
          break
        }
      }
    }
    setImagesSelected(imgsSelected)
  },[images])

  
  return (
    <>

      <Header id="PictureContainer--header">

        {!images && <span className="minor">It looks like you haven't uploaded any picture yet.</span>}

      </Header>

      <Container className="PictureContainer--content">
            
        {
          !showDeletedImages && 
            <div className="image-wrapper">
              <UploadAndDisplayImage image={handleSetImage} />
            </div>
        }

        {
          showDeletedImages && 
            (
              images.length>0 ? 
                <>
                  <span className="under">You can either recover or permanently delete them.</span>
                  <span className="under">You can click on the top left trash bin icon on each picture to permanently delete the pictures one at the time.</span>
                  <p> OR </p>
                  <span className="under">Click on the top center select icon on each picture to select each picture you want to later permanently delete.
                  Later you can click on the delete selected button to permanently delete at ones the pictures you selected.</span>
                </> 
              : 
                <span className="under">You didn't temporarily delete any picture yet</span>
            )
        }
        {
          showDeletedImages && images.length>0 && 
          <div className='image-wrapper' title='permanently remove selected pictures'>
            <RemoveSelected BASE_URL={BASE_URL} onClick={deleteSelectedImages}>
            {
              imagesSelected ?
                <button>+</button>
              :
                <span>Select some image to permanently delete them at once</span>
            }
            </RemoveSelected>
          </div>
        }

       

        { images && images.map((image, imageIndex) =>
          
          <div className={`image-wrapper ${image.selected ? 'image-wrapper-selected' : ''} `}>
            
            <div key="imageIndex" >

              <PictureHolder mini={mini} image={image} />

              {/* <div className="image-container">
                <img className="loaded-image"
                  src={`${mini}${image.img_mini_name}`} 
                  alt={image.img_mini_name} 
                  title={image.img_mini_name}
                />
              </div> */}

              <div className="loaded-image">
                <div className='loaded-image-top'>
                  {
                    showDeletedImages ?
                      <>
                        {/* <div className='remove' title="permanently delete" onClick={(e)=>handleDelete(e, image, imageIndex)}> */}
                        <div className='remove' title="permanently delete" onClick={()=>handleDelete(image)}>
                          <DeleteForeverIcon/>
                        </div>
                        <div className='remove' title="select" onClick={(e)=>handleSelectImage(e, image, imageIndex, 'active')}>
                          <TouchAppIcon/>
                        </div>
                        <div className='remove' title="restore" onClick={(e)=>handleImageStatus(e, image, imageIndex, 'active')}>
                          <SettingsBackupRestoreIcon/>
                        </div>
                      </>
                    :
                      <>
                        <div className='remove' title="move to trash bin" onClick={(e)=>handleImageStatus(e, image, imageIndex, 'inactive')}>
                          <DeleteIcon/>
                        </div>

                        <div className='addToFolder' >
                          <div className='dropbtn' title="add to folder"><DriveFileMoveIcon/></div>
                          {albums && 
                            <div className="dropdown-content">
                              {
                                albums.map((album, albumIndex) => (
                                  <>
                                    {
                                      ( !assoc || (
                                          assoc 
                                            && 
                                          !assoc.find((a, aIndex) => album.id === a.album_id && a.img_id === image.id)
                                        )
                                      ) 
                                        &&      
                                          <span 
                                            key={`${albumIndex}-album`} 
                                            onClick={
                                              (e)=>handleAddToFolder(
                                                e, 
                                                image.id, 
                                                image.img_mini_name,
                                                album.album_name, 
                                                album.id,
                                                album.album_usr
                                              )
                                            }
                                          >
                                            {album.album_name}
                                          </span>
                                      
                                    }
                                  </>
                                ))
                              }
                            </div>
                          }
                        </div>
                        
                      </>
                  }
                </div>
                {/* <div className='expand' onClick={()=>handleExpand(imageIndex)}> */}
                {/* <div className='expand' title="see full size" onClick={()=>handleImageModalExpand(image)}> */}
                <div className='expand' title="see full size" onClick={()=>handleImageModalExpand(image)}>
                  <AspectRatioIcon sx={{ fontSize: 60 }}/>
                </div>
                <div className='save'>
                  <SaveAltIcon/>
                </div>
              </div>
            </div> 

          </div>
            
        )} 

      </Container>

    </>

  )
}

export default PictureContainer;

const RemoveSelected = styled.div `

  display: flex;
  justify-content: center;
  align-items: center;


  button {

    /* padding: 150px 0 0 0; */
    height: 100px;
    width: 100px;
    overflow: hidden;
    -webkit-box-sizing: border-box;
    -moz-box-sizing: border-box;
    box-sizing: border-box;
    background: url('${props=>props.BASE_URL}/assets/icons/delete.png') center center no-repeat ;
    /* border-radius: 20px; */
    border: 1px solid transparent;
    /* background-size: 120px 120px; */
    background-size: 100%;

  }

  span {
    height: 100%;
    width: 80%;
    text-align: center;
    padding: 0px;
    margin: 0px;
    font-size: 1rem !important;
    /* color: red; */
    /* border: 1px solid orange; */


  }

`

const Header = styled.div `
  display: flex;
  flex-direction: column;
  /* justify-content: center; */
  align-items: center;

  span.strong {
    font-size: 1.8rem;
    font-weight: 600;
    text-align: center;

    div {
      color: orange
    }

    @media screen AND (max-width: 575px) {
      font-size: 1.4rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: 1rem;
    }
  }

  span.under {
    font-size: 1.6rem;
    font-weight: 400;
    text-align: center;

    div {
      color: orange
    }

    @media screen AND (max-width: 575px) {
      font-size: 1.3rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: .9rem;
    }
  }

  span.minor {
    margin-top: 30px;
    font-size: 1.2rem;
    font-weight: 400;
    text-align: center;

    @media screen AND (max-width: 575px) {
      font-size: 1rem;
    }
    @media screen AND (max-width: 375px) {
      font-size: .8rem;
    }
  }

  span.createAbum {
    display: flex;
    justify-content: center;
    align-items: center;
    
    cursor: pointer;
    width: 100px;
    height: 60px;
    /* border: 1px solid orange; */
    font-size: 1.4rem;
    margin-top: 1rem;
    margin-right: 2rem;
    text-decoration: underline;
    position: relative;

    .icon {
        position: absolute;
      }
    .text {
      position: absolute;

      color: orange;
      font-weight: 700;
      /* background-color: rgba(0,0,0,.6); */
      width: 100%;
      height: 100%;

      display: flex;
      justify-content: center;
      align-items: center;
    }

    
  }

  div.albums {
    display: flex;
    flex-direction: row;
    justify-content: center;
    flex-wrap: wrap;

    margin-top: 3rem;

    div.no-album {
      display: flex;
      flex-direction: column;
      justify-content: center;
      align-items: center;
      gap: 2rem;
    }
    
    div.album {
      display: flex;
      justify-content: center;
      align-items: center;

      position: relative;
      width: 200px;
      height: 160px;
      border: 1px solid orange;
      font-size: 1.4rem;
      /* margin-right: 2rem; */
      text-decoration: underline;
      cursor: pointer;
        overflow: hidden;

      .icon {
        position: absolute;

        img {
          width: 200px; 
          height: 160px; 
          /* width: 100%;
          height: 100%; */
        }
      }
      .textContainer {
        position: absolute;

        color: orange;
        font-weight: 700;
        /* background-color: rgba(0, 0, 0, .6); */
        width: 100%;
        height: 100%;

        display: flex;
        /* flex-direction: column; */
        justify-content: center;
        align-items: center;
        
        .screen-one, .screen-two {
          position: absolute;
          width: 100%;
          height: 100%;
          /* border: 1px solid red; */
        }
        .screen-one {
          background-color: rgba(0, 0, 0, .1);
        }
        .screen-two {
          background-color: rgba(0, 0, 0, .1);
        }

        .images-count {
          /* font-family: 'Londrina Outline', cursive; */

          position: absolute;
          font-size: 6rem;
          text-align: center;
          color: rgba(255, 165, 0, .6);
          /* color: rgba(185, 185, 185, .6); */
        }

        .text {
          position: absolute;
        }
        
      }
    }
  }
`;

const Container = styled.div `

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  flex-wrap: wrap;

  margin: 0px;
  margin-top: 2.8rem;
  /* border: 1px solid red; */

  .image-wrapper {
    position: relative;

    width: 150px;    //200px;
    height: 112.5px;    //130px;
    /* margin: 20px 10px; */
    border: 1px solid orange;
    overflow: hidden;
    background-color: rgba(0,0,0,0);

    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;

    /* div.image-container {
      max-height: 130px;
      aspect-ratio: 4/3;

      img.loaded-image {
        position: relative;
        height: 135px;
        image-orientation: from-image; 
        // image-orientation: none; 
      }
    }  */

    div.loaded-image {
      position: absolute;
      top: 0;
      left: 0;
      /* display: none; */
      width: 100%;
      height: 100%;
      background-color: rgba(0,0,0,0);
      color: transparent;
      transition: all .7s ease-in-out;

      display: flex;
      flex-direction: column;
      justify-content: space-between;
      /* justify-content: flex-start; */

      .loaded-image-top {
        display: flex;
        flex-direction: row-reverse;
        justify-content: space-between;
        align-items: center;

        /* border: 1px solid green; */


      }

      .remove {
        text-align: right;
        padding: 0;
        margin: 0;
        line-height: .8rem;
      }
      .addToFolder {
        /* text-align: left; */
        padding: 0;
        margin: 0;
        line-height: .8rem;

        /* Dropdown Content (Hidden by Default) */
        .dropdown-content {
          display: none;
          position: absolute;
          background-color: #f1f1f1;
          min-width: 160px;
          box-shadow: 0px 8px 16px 0px rgba(0,0,0,0.2);
          z-index: 1;
          overflow-y: auto;
          margin-left: 10px;
          padding: 2px 0px;
        }

        /* Spans inside the dropdown */
        .dropdown-content span {
          color: black;
          padding: 2px 6px;
          text-decoration: none;
          display: block;
          font-size: .8rem;
        }

        /* Change color of dropdown links on hover */
        .dropdown-content span:hover {background-color: #ddd;}

        /* Show the dropdown menu on hover */
        &:hover .dropdown-content {display: block;}

        /* Change the background color of the dropdown button when the dropdown content is shown */
        /* &:hover .dropbtn {background-color: #3e8e41;} */
      }

      .expand {
        text-align: center;
        padding: 0;
        margin: 0;
      }
      .save {
        text-align: right;
        padding: 0;
        margin: 0;
        line-height: .8rem;
      }

      &:hover {
        background-color: rgba(0,0,0,0.4);
        color: #d1d1d1;
      }

      div {
        font-size: 1.4rem;
        /* text-align: center; */
        cursor: pointer;
        /* margin-bottom: 10px; */
      }
    }


    div.cross {
      color: red;
      margin: 0;
      padding: 0;
      font-size: 6rem;
      font-weight: 100;
    }

    &:last-child {
      margin-right: 0;
    }

    img {
      width: 100%;
    }
  }

  .image-wrapper-selected {
    border: 1px solid red;

  }

  span {
    font-size: 1.4rem;
    font-weight: 700;
  }

`;